import {QueryParamsEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {useEffect, useState} from 'react';

import {ExamRequestResultTypeEnum} from 'domain/usecases/private/exam-results/get-exam-requests';
import {EXAMS_FILTERS} from './constants';

const {title} = translations['pt-br'].privateFlow.examResults.filter;

export const useFilterHeader = () => {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {examType: selectedType} = SEARCH_PARAMS;
	const [openDrawerState, setOpenDrawerState] = useState(false);
	const IS_ALL = selectedType === ExamRequestResultTypeEnum.ALL || selectedType.length === 0;
	const [selectedFilterState, setSelectedFilterState] = useState(
		IS_ALL ? ExamRequestResultTypeEnum.ALL : selectedType,
	);

	const handleOpenDrawer = () => {
		setOpenDrawerState(true);
	};

	const handleCloseDrawer = () => {
		setOpenDrawerState(false);
	};

	const listFilters = [
		{
			categoryTitle: title,
			categoryItemsList: EXAMS_FILTERS?.map(currentFilter => ({
				active: selectedFilterState === currentFilter.category,
				title: currentFilter.label,
				onClick: () => setSelectedFilterState(currentFilter.category),
				dataTagId: currentFilter.dataTagId,
			})),
		},
	];

	const handleClearSearchParams = () => {
		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.EXAM_TYPE);
			return prev;
		});
	};

	const handleSearchParams = (type: string) => {
		if (type === ExamRequestResultTypeEnum.ALL) {
			handleClearSearchParams();
			return;
		}
		setSearchParams(prev => {
			prev.set(QueryParamsEnum.EXAM_TYPE, type);
			return prev;
		});
	};

	const handleApplyFilter = () => {
		handleSearchParams(selectedFilterState);
		setOpenDrawerState(false);
	};

	const handleClearFilter = () => {
		handleClearSearchParams();
		setSelectedFilterState(ExamRequestResultTypeEnum.ALL);
		setOpenDrawerState(false);
	};

	useEffect(() => {
		if (!selectedType) {
			setSelectedFilterState(ExamRequestResultTypeEnum.ALL);
		}
	}, [selectedType]);

	return {
		openDrawerState,
		handleOpenDrawer,
		handleCloseDrawer,
		listFilters,
		handleApplyFilter,
		handleClearFilter,
		IS_ALL,
	};
};
